import React, { useState } from 'react';
import ButtonBack from './images/x.png';
import useWeb3 from '../hooks/useSolanaWeb3';
import { toast } from 'react-hot-toast';
import useFetchNfts from '../hooks/useFetchNfts';

function AmountSelection({ onClose, resetSlider, selectType, antInfo, imageUri }) {

  const { antCoinBalance, fetchBlockchainData, handleWorkforceStake, handleBossesStake, fetchAllBalances, fetchAssignedNfts,fetchBossedNfts } = useWeb3();
  const { fetchNfts } = useFetchNfts()
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false)

  const handleInputChange = (event) => {
    const newValue = parseInt(event.target.value);
    if (!isNaN(newValue)) {
      setValue(newValue);
    }
  };

  const handleIncrement = () => {
    if (value < Number(antCoinBalance) - 1) {
      setValue((prevValue) => prevValue + 1);
    }
  };

  const handleDecrement = () => {
    if (value > 0) {
      setValue((prevValue) => prevValue - 1);
    }
  };

  const handleUseMax = () => {
    const maxValue = Math.min(antCoinBalance, 50000);
    setValue(maxValue);
  };

  const handleStake = async () => {
    console.log('handleStake')
    if (selectType === "bosses") {
      console.log("bosses clicked")
      try {
        setLoading(true)
        await handleBossesStake(antInfo, imageUri, value);
        resetSlider()
        await fetchBlockchainData();
        await fetchAllBalances();
        await fetchBossedNfts();
        toast.success("Successfully Assigned");
        onClose();
      } catch (err) {
        console.log("Bosses Assign Error:", err)
        switch (true) {
          case String(err).includes("Bosses: ant coin stake amount exceed the limit amount"):
            toast.error("$ANTC stake amount has been limited.")
            break;
          case String(err).includes("User rejected request"):
            toast.error("User rejected request")
            break;
          case String(err).includes("Bosses: you are not owner of this token"):
            toast.error("You are not owner of this token")
            break;
          case String(err).includes("Bosses: insufficient ant coin balance"):
            toast.error("Insufficient $ANTC balance")
            break;
          case String(err).includes("Bosses: bosses pools info has not been set yet"):
            toast.error("Pools Info hasn't been set yet.")
            break;
          case String(err).includes("Bosses: ant level must be greater than the minimum required pool level"):
            toast.error("No match pool for this token. Check the pool requirement.")
            break;
          case String(err).includes("Bosses: stake amount should be >= 0"):
            toast.error("stake amount should be > 0")
            break;
          default:
            toast.error("Something went wrong!")
            break;
        }
      } finally {
        setLoading(false);
      }
    } else if (selectType === "Workforce-Stake") {
      console.log("workforce clicked")
      try {
        setLoading(true)
        await handleWorkforceStake(antInfo, imageUri, value)
        await fetchAllBalances();
        await fetchNfts(5);
        await fetchAssignedNfts();
        toast.success("Successfully Assigned");
        onClose()
      } catch (err) {
        console.log("Workforce Assign Error:", err)
        switch (true) {
          case String(err).includes("Workforce: ant coin stake amount should be > 0"):
            toast.error("should be > 0")
            break;
          case String(err).includes("User rejected request"):
            toast.error("User rejected request")
            break;
          case String(err).includes("Workforce: you are not owner of this token"):
            toast.error("You are not owner of this token")
            break;
          case String(err).includes("Workforce: ant coin stake amount exceed the limit amount"):
            toast.error("Your desired $ANTC amount exceed the limit amount")
            break;
          case String(err).includes("Workforce: insufficient ant coin balance"):
            toast.error("Insufficient $ANTC balance")
            break;
          default:
            toast.error("Something went wrong!")
            break;
        }
      } finally {
        setLoading(false);
      }
    }
  }

  return (
    <div className="popup-container">
      <div className="popup" id="stake-popup">
        <button className="button-close" onClick={onClose}>
          <img src={ButtonBack} alt="Close button" />
        </button>
        <div className="popupinfo-holder" id="stake-amount">
          <h1>CHOOSE AMOUNT TO STAKE</h1>
          <div>
            <p>Note that your ANT + ANT Coins will be locked until you redeem your ANT. Upon redeeming your ANT will lose all the levels. </p>
          </div>
          <div className="amount-box" id="amount-box-stake">
            <button onClick={handleDecrement}>-</button>
            <input
              type="number"
              value={value}
              onChange={handleInputChange}
              max={Math.min(antCoinBalance, 50000)}
            />
            <button onClick={handleIncrement}>+</button>
          </div>
          <button onClick={handleUseMax}>USE MAX COINS</button>
          <button className="buy-button" onClick={handleStake} disabled={loading}>
            <span>{loading ? "Loading..." : "CONFIRM"}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default AmountSelection;